import http from '@axios'
import paramsConverter from './utils/paramsConverter'

const resource = '/api/v1/question-bank/content'

export default {
  list(params = {}) {
    const paramsString = paramsConverter(params)

    return http.get(`${resource}${paramsString}`)
  },
  add(questionContent) {
    return http.post(`${resource}`, questionContent, { headers: { 'Content-Type': 'multipart/form-data' } })
    // return http.post(`${resource}`, questionContent, { headers: { 'Content-Type': 'multipart/form-data' } })
  },
  get(uuid) {
    return http.get(`${resource}/${uuid}`)
  },
  update(questionContent, uuid) {
    return http.post(`${resource}/${uuid}?_method=PATCH`, questionContent, { headers: { 'Content-Type': 'multipart/form-data' } })
  },
  destroy(uuid) {
    return http.delete(`${resource}/${uuid}`)
  },
}
